import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./index.scss";

class NewsletterForm extends Component {
  render() {
    return (
      <div className="form-wrapper">
        <form>
          <div className="row">
            <div className="col-lg-8 p-0">
              <div className="form-group">
                <div
                  className="form-group has-search  search-field"
                  style={{
                    background: "var(--searchBg)",
                    borderRadius: "var(--searchBorderRadius)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className="form-control-feedback ml-1 pt-2"
                    style={{ color: "var(--news-letter-icon)" }}
                  />
                  <input
                    type="Email"
                    className="form-control border-0"
                    placeholder="your.email@example.com"
                    style={{ background: "var(--searchBg)" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox1"
                      value="option1"
                    />
                    <label
                      className="form-check-label newsletter-check-label"
                      htmlFor="inlineCheckbox1"
                    >
                      Updates and alerts
                    </label>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox2"
                      value="option2"
                    />
                    <label
                      className="form-check-label newsletter-check-label"
                      htmlFor="inlineCheckbox2"
                    >
                      Monthly newsletter
                    </label>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox3"
                      value="option3"
                    />
                    <label
                      className="form-check-label newsletter-check-label"
                      htmlFor="inlineCheckbox3"
                    >
                      Weekly content digest
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 subscribe-btn-col">
              <button type="submit" className="btn btn-subscribe w-100">
                Subscribe{" "}
                <img
                  className="img-fluid submit-btn-icon"
                  src={require("../../../assets/icons/subscribe.png")}
                />
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default NewsletterForm;
